export default __webpack_public_path__ + "static/media/Line.31564316.svg";